import { Conversation } from '@elevenlabs/client';
import { Nullable } from './types';

let conversation: Conversation;

/**
 * @description start conversation with eleven labs agent
 * @param agent_id agent id to identify connection
 * @param status html element to display connection status
 */
async function startConversation(
  stream: MediaStream,
  agent_id: string,
  status: HTMLParagraphElement
): Promise<Nullable<MediaStream>> {
  try {
    // Ensure we have microphone access

    // Launch the WebSocket session with your agent
    conversation = await Conversation.startSession({
      agentId: agent_id, // pass your agent ID here

      onConnect: () => {
        status.textContent = 'Connected';
        // startButton.disabled = true;
        // stopButton.disabled = false;
      },
      onDisconnect: () => {
        status.textContent = 'Disconnected';
        // startButton.disabled = false;
        // stopButton.disabled = true;
      },
      onError: (err: any) => {
        console.error('Conversation error:', err);
      },

      //@ts-ignore
      onModeChange: ({ mode }) => {
        // mode is 'listening' or 'speaking'
        status.textContent = mode as string;
      },
    });

    return stream;
  } catch (err) {
    console.error('Failed to start conversation:', err);
    return null;
  }
}

/**
 * @description stop the conversation
 */
async function stopConversation(): Promise<void> {
  if (conversation) {
    await conversation.endSession();
  }
}

export { startConversation, stopConversation };
